import React from 'react'
import { FormattedMessage } from 'react-intl';
import "./styles/LinkRequiredInformation.scss";
import { useStateMachine } from 'little-state-machine';
import { updateAction } from 'scenes/ProjectMultiStepForm/store';
import infoIcon from "./img/info-icon.png";
import useMediaQuery from 'utils/hooks/useMediaQuery';
import classNames from 'classnames';

const LinkRequiredInformation = () => {
  const isMobile = useMediaQuery("(max-width: 1199px)");
  const { state, actions } = useStateMachine({ updateAction });

  const openDownloadFormatsModal = () => {
    actions.updateAction({
      ...state,
      showDownloadFormatsModal: true,
    });
  }

  return (
    <div
      className={classNames({
        "bottom-positioning position-absolute": !isMobile,
        "link-required-info--container p-5 text-center d-flex align-items-center justify-content-center": !isMobile,
        "d-inline": true
      })}
    >
      <span onClick={openDownloadFormatsModal} className='link-required-info--text text-decoration font-weight-bold mb-0'>
        <img src={infoIcon} alt="info-icon" />
        <FormattedMessage
          id="ProjectStepFormDisclaimer.stepGuide.numbers"
          defaultMessage="Información requerida"
        />
      </span>
    </div>
  );
}

export default LinkRequiredInformation